import $http from '../../../axios-instance';
import Swal from 'sweetalert2'
import { validarPermisoComponente } from '../../../plugins/acl';

/**
 * Método para guardar otros tlv de un producto químico.
 * 
 * @param {*} param0 
 */
export async function guardaOtrosTlv({ commit, state, rootState, dispatch }) {
    if (validarPermisoComponente('administracion-otros-tlv-producto')) {
        var producto = rootState.productos.selectedProduct.id;
        if (producto == "") {
            producto = rootState.productos.selectedProduct.Idproducto;
        }

        var IdProducto = parseInt(producto);
        state.selectedOtrosTlv.id_producto = IdProducto;

        await $http.post('adm_productos/otros_tlv/crear', state.selectedOtrosTlv)
            .then(async (response) => {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 3000
                })
                await dispatch('getOtrosTlv');
                //commit('setProduct', response.data.data)
                state.error = false
            })
            .catch((error) => {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error.message + '<br> ' + error.errors,
                    showConfirmButton: true,
                    timer: 5000
                })
            })
    }
}

/**
 * Método para obtener otros tlv de un producto químico.
 * 
 * @param {*} param0 
 */
export async function getOtrosTlv({ commit, state, rootState }) {
    if (validarPermisoComponente('administracion-otros-tlv-producto')) {
        var producto = rootState.productos.selectedProduct.id;
        if (producto == "") {
            producto = rootState.productos.selectedProduct.Idproducto;
        }

        await $http.get(`adm_productos/otros_tlv/${producto}`, { params: state.filtro })
            .then((response) => {
                commit('setOtrosTlv', response.data.data)
            })
            .catch((error) => {

            })
    }
}

/**
 * Método para actualizar otros tlv de un producto químico.
 * 
 * @param {*} param0 
 * @param {*} otroTlv contiene la información de otros tlv a actualizar.
 */
export async function updateOtrosTlv({ dispatch, state, rootState }) {
    if (validarPermisoComponente('administracion-otros-tlv-producto')) {
        var producto = rootState.productos.selectedProduct.id;
        if (producto == "") {
            producto = rootState.productos.selectedProduct.Idproducto;
        }

        await $http.put(`adm_productos/otros_tlv/editar/${producto}`, state.selectedOtrosTlv)
            .then(async (response) => {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 3000
                })
                await dispatch('getOtrosTlv');
                state.error = false
            })
            .catch((error) => {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error.message + '<br> ' + error.errors,
                    showConfirmButton: true,
                    timer: 5000
                })
            })
    }
}

/**
 * Método para eliminar otros tlv de un producto químico.
 * 
 * @param {*} param0 
 * @param {*} otroTlv contiene la información de otros tlv de un producto químico.
 */
export async function deleteOtrosTlv({ commit, dispatch, state, rootState }, otroTlv) {
    if (validarPermisoComponente('administracion-otros-tlv-producto')) {
        state.selectedOtrosTlv.idOtroTlv = otroTlv.id;
        var producto = rootState.productos.selectedProduct.id;
        if (producto == "") {
            producto = rootState.productos.selectedProduct.Idproducto;
        }

        await $http.post(`adm_productos/otros_tlv/inactivar/${producto}`, state.selectedOtrosTlv)
            .then(async (response) => {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 3000
                })
                if (state.dataTlv.length === 1 && state.filtro.page > 1) {
                    commit('setPage', 1);
                }
                await dispatch('getOtrosTlv');
                state.error = false
            })
            .catch((error) => {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error.message + '<br> ' + error.errors,
                    showConfirmButton: true,
                    timer: 5000
                })
            })
    }
}